import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { User } from '../model/user';
import { CookieService } from 'ngx-cookie-service';
import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root'
})
export class LoggingService {

  appInsights: ApplicationInsights;

  constructor(private cookieService: CookieService, private commonService: CommonService) {
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: environment.appInsights.instrumentationKey,
        enableAutoRouteTracking: true // option to log all route changes
      }
    });
    this.appInsights.loadAppInsights();
  }
  logPageView(name?: string, url?: string) {
    this.appInsights.trackPageView({
      name: name,
      uri: url
    });
  }
  logEvent(name: string, properties?: { [key: string]: any }) {
    this.appInsights.trackEvent({ name: name }, properties);
  }
  logMetric(name: string, average: number, properties?: { [key: string]: any }) {
    this.appInsights.trackMetric({ name: name, average: average }, properties);
  }
  logException(exception: Error, severityLevel?: number) {
    exception.message = this.appendMessage(exception.message);
    this.appInsights.trackException({ exception: exception, severityLevel: severityLevel });
  }
  logTrace(message: string, properties?: { [key: string]: any }) {
    message = this.appendMessage(message);
    this.appInsights.trackTrace({ message: message }, properties);
  }

  public logCustomEvent(onEvent: string): void {
    let xbc_userData: User = this.commonService.getUserData();
    this.logEvent('User Action', { "User": xbc_userData?.employeeId, "Operation": onEvent });
  }

  private appendMessage(message: string): string {
    let xbc_session = this.cookieService.get(AuthService.userSessionKey)!;
    let xbc_userData: User = this.commonService.getUserData();
    message = `Session ID: ${xbc_session}, User: ${xbc_userData?.employeeId} Message: ${message}`;
    return message;
  }
}